import { getInheritedClass, Metadata, Store } from '@tencent/workbench-core';
import { ActionPointMetadata } from '../providers/action-point/action-point-metadata.js';

class ActionPointRegistry {
    /**
     * 从父类中检索所有的 ActionPoint 并存储在 Registry 中
     */
    static inherit(ctrlClass) {
        const actionPoints = [];
        let inheritedClass = getInheritedClass(ctrlClass);
        while (inheritedClass && ActionPointRegistry.hasActionPoints(inheritedClass)) {
            this.getOwnActionPoints(inheritedClass).forEach((actionPointInheritedClass) => {
                const actionPoint = actionPointInheritedClass.inherit(ctrlClass);
                actionPoints.push(actionPoint);
            });
            inheritedClass = getInheritedClass(inheritedClass);
        }
        return actionPoints;
    }
    /**
     * 从给定的类中返回所有的 ActionPoint, 此方法不返回给定类的父类的 ActionPoint
     */
    static getOwnActionPoints(target) {
        if (!this.hasActionPoints(target)) {
            Metadata.set(ActionPointRegistry.name, [], target);
        }
        return Metadata.getOwn(ActionPointRegistry.name, target);
    }
    /**
     * 从给定的类中获得包括父类在内的所有 ActionPoint
     */
    static getActionPoints(target) {
        return this.getOwnActionPoints(target); // .concat(this.inherit(target));
    }
    static hasActionPoints(target) {
        return Metadata.hasOwn(ActionPointRegistry.name, target);
    }
    static get(target, method) {
        if (!this.has(target, method)) {
            const control = new ActionPointMetadata(target, method);
            ActionPointRegistry.getActionPoints(target).push(control);
            Metadata.set(ActionPointRegistry.name, control, target, method);
        }
        return Metadata.getOwn(ActionPointRegistry.name, target, method);
    }
    static has(target, method) {
        return Metadata.hasOwn(ActionPointRegistry.name, target, method);
    }
    static useBefore(target, targetKey, args) {
        this.get(target, targetKey).before(args);
        return this;
    }
    static use(target, targetKey, args) {
        this.get(target, targetKey).merge(args);
        return this;
    }
    static useAfter(target, targetKey, args) {
        this.get(target, targetKey).after(args);
        return this;
    }
    static store(targetClass, methodClassName) {
        return Store.from(targetClass, methodClassName, Object.getOwnPropertyDescriptor(targetClass, methodClassName));
    }
    static setMetadata(key, value, targetClass, methodClassName) {
        ActionPointRegistry.store(targetClass, methodClassName).set(key, value);
        return ActionPointRegistry;
    }
    static getMetadata(key, targetClass, methodClassName) {
        return ActionPointRegistry.store(targetClass, methodClassName).get(key);
    }
}

export { ActionPointRegistry };
//# sourceMappingURL=action-point-registry.js.map
